<script>
	import { onMount } from 'svelte';
	import { getBacthData } from "../../../../api/Batch";
    import { handleSystemErrors } from '../../../../api/utils';


	export let batchFilter = null;

	var user = null;

	var companyName = null;


	export let batchFullData = null;
	
	let batchData = [{}];
	let batchDataReady = false;
	let pageNumber = 0;
	var batchFullData_length = 0;
	var maxPageNumber = 0;
	var rowsPerPage = 12;
	var lastPageEl = 0;


	let popupState = false;
	let popupId = -1;



	const dummyArray = Array(rowsPerPage).fill({id:'dummy'});

	var dyanamicDummyArray = [];


	async function getBatchDataHandler(userData){

		const res = await getBacthData(userData);

			// console.log(res);

			if(res.status == "valid"){

				
				batchFullData = res.batchData; 
				batchFullData_length = batchFullData.length;

				if(batchFullData_length > 0){
					batchDataReady = true;
					calcTablePages(batchFullData_length);
					batchData = batchFullData.slice(0,rowsPerPage);
				}
				else{
					batchDataReady = true;
					batchData = [];
					dyanamicDummyArray = dummyArray.slice(0,rowsPerPage);
					dyanamicDummyArray = dyanamicDummyArray;
				}

				if(batchFilter != null){

					batchFilter = null;
				}
					
			}
			else if(res.status == "error"){
				// console.log('res.userData',res.err);
				await handleSystemErrors(res.err);
			}
				
	}

	$:{

		if(batchFilter != null){
			
			let userData = {
				email: user.email,
				companyName: companyName,
				batchFilter: batchFilter
			}

			getBatchDataHandler(userData);	

		}
	}



	onMount( async () => {
		
		user = localStorage.getItem('user');

		if(user != null){

			user =  JSON.parse(user);
			companyName = user.company;


			if(companyName != 'none' ){

				var userData = {
					email: user.email,
					companyName: companyName

				}

				getBatchDataHandler(userData);
			}	
		}
	});


	$:{

	 	if(lastPageEl < rowsPerPage && lastPageEl != 0 ){

	 		let missingEl = rowsPerPage - lastPageEl;
	 		dyanamicDummyArray = dummyArray.slice(0,missingEl);

	 	}
	 	else{
	 		
	 		if(pageNumber == 0 && batchFullData_length > 0){

	 			let missingEl = rowsPerPage - batchFullData_length;
	 			dyanamicDummyArray = dummyArray.slice(0,missingEl);

	 		}

	 	}
	}


	function calcTablePages(totalSize){

		var aux = 0;
		var integerPart = 0;
		var decimalPart = 0;
		

		aux = totalSize/rowsPerPage;

		integerPart = parseInt(aux);
		decimalPart = parseInt((aux % 1).toFixed(2).substring(2));
		

		if(decimalPart == 0 ){

			maxPageNumber = integerPart-1;

		}
		else{

			decimalPart = decimalPart/100;

			lastPageEl = (decimalPart * (integerPart*rowsPerPage))/integerPart;

			maxPageNumber = Math.ceil(aux)-1;



		}
	}


	function handleTablePage(e){

		var id = e.target.id;

		if(id == 'next'){

			if(pageNumber != maxPageNumber){
				pageNumber++;

				var startIndex = rowsPerPage * pageNumber;
				var endIndex = startIndex + rowsPerPage;

				batchData = batchFullData.slice(startIndex,endIndex);	
			}
			else{

			}
			

		}
		else if('back'){

			if(pageNumber != 0 ){
				pageNumber--;

				var startIndex = rowsPerPage * pageNumber;
				var endIndex = startIndex +rowsPerPage;
				batchData = batchFullData.slice(startIndex,endIndex);	
			}
			else{

			}
			


		}
		else{

		}
	}


	function popupHandler(index){
		popupState = true;
		popupId = index;
	}

	function inspectItemHandler(e,index){

		var id = e.target.id;

		var batchID = batchFullData[index].BatchID;

		if(id == 'inspect'){

			
			var companyName = batchFullData[index].Company;
			window.open("/batch/" + batchID, "_blank");

		}
		else if(id == 'edit'){

			window.open("/edit/" + batchID, "_blank");
			
		}
	}
	


</script>

<div class="tableContainer">

	<div class="table">
		<div class="tableHeader">

			<div class="tableHeaderItem">
				
			</div>
			<div class="tableHeaderItem">
				Product
			</div>
			<div class="tableHeaderItem">
				Batch ID
			</div>
			<div class="tableHeaderItem">
				Data Type
			</div>
			<div class="tableHeaderItem">
				Production Date
			</div>
			<div class="tableHeaderItem">
				Insertion Date
			</div>
			<div class="tableHeaderItem">

			</div>

		</div>

		{#if batchDataReady}
			{#each batchData as batch, index}
				<div class="tableRow" id={index}>

					<div class="tableRowItem" id="batchIndex">
						{index + (pageNumber*rowsPerPage)}
					</div>
					<div class="tableRowItem" id="batchProduct">
						{batch.Product}
					</div>

					<div class="tableRowItem" id="batchID">
						{batch.BatchID}	
					</div>

					<div class="tableRowItem" id="batchID">
						{batch.DataType}	
					</div>

					<div class="tableRowItem" id="batchProductionDate">
						{batch.ProductionDate}
					</div>

					<div class="tableRowItem" id="batchInsertionDate">
						{batch.InsertionDate}		
					</div>

					<div class="tableRowItem" id='rowActionBtn'>

						<div class="inspectIcon"  on:click={()=> popupHandler(index + (pageNumber*rowsPerPage))}>
							{#if popupState && index + (pageNumber*rowsPerPage) == popupId }
								<div class="popupContainer">
									<div class="popupActionBtn" id="inspect" on:click={(e)=> inspectItemHandler(e,index + (pageNumber*rowsPerPage))}>
										Inspect
									</div>

									<div class="popupActionBtn" id="edit" on:click={(e)=> inspectItemHandler(e,index + (pageNumber*rowsPerPage))}>
										Edit
									</div>

								</div>
							{:else}
								<i class="fa-solid fa-ellipsis"></i>
							{/if}

													
						</div>

						

						
					</div>
					
				</div>
			{/each}

			{#if pageNumber == maxPageNumber }
				{#each dyanamicDummyArray as dummy}

					<div class="tableRow">
					</div>
				{/each}
			{/if}
		{:else}

			{#each dummyArray as dummy}

				<div class="tableRow">
					
				</div>
			{/each}
		{/if}

		<div class="tableActionsContainer">

			{#if batchFullData_length > 0}

				<div class="tablePageNumber">
					{pageNumber+1}/{maxPageNumber+1}				
				</div>

			{:else}
				<div class="tablePageNumber">
					0/0				
				</div>
			{/if}

			<div class="pagesBtnContainer">

				<div class="pagesBtn" id="back" on:click={(e) => handleTablePage(e)}>
					 <i class="fa-solid fa-caret-left"></i>
				</div>

				<div class="pagesBtn" id="next" on:click={(e) => handleTablePage(e)}>
					<i class="fa-solid fa-caret-right"></i>
				</div>

			</div>
			
		</div>	
	</div>
	
	
</div>



<style>

	.tableActionsContainer{
		width: 95%;
		height: 10%;
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		
	}


	.pagesBtnContainer{
		width: 10%;
		height: 100%;
		display: flex;
		flex-direction: row;
	}

	.pagesBtn{
		width: 50%;
		height: 100%;
		color: black;
		opacity: 0.8;
		display: flex;
		align-items: center;
		justify-content: center;
		/*background-color: orange;*/
		cursor: pointer;
	}


	.tablePageNumber{
		width: 10%;
		height: 100%;
		color: black;
		display: flex;
		align-items: center;
		justify-content: center;
	}


	.dummyBtn{
		/*background-color: yellow;*/
		width: 20%;
		height: 100%;
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tableContainer{
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.table{

		width: 90%;
		height: 90%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		z-index: 19;
		background-color: white;
		border-radius: 5px;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
	}

	.tableHeader{
		width:95%;
		height: 5%;
		margin-top: 3.5%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
	}

	.tableHeaderItem{
		width: 20%;
		height: 100%;
		color: black;
		/*opacity: 0.8;*/
		font-size: 0.9114583333333334vw;
		font-weight: 700;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		/*background-color: darkred;*/

	}

	.tableRow{

		width:95%;
		height: 10%;
		box-shadow: 0px 1.52vw 0.1953125vw -1.52vw #606060;
		opacity: 0.8;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		
	}

	.tableRow:hover{
		/*background-color: #B4B4B4;*/
	
	}

	.tableRow:hover .tableRowItem{
		
		color: var(--brand-accent);
	}

	.tableRowItem{

		width: 20%;
		height: 100%;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		/*flex-grow: 2;*/
		/*flex-shrink: 2;*/
		

	}

	.tableRowItem:nth-child(1), .tableHeaderItem:nth-child(1){
		width: 5% !important;
	}

	.tableRowItem:nth-last-child(1), .tableHeaderItem:nth-last-child(1){
		width: 10% !important;
	}
	

	.inspectIcon{
		width: 100%;
		height: 100%;
		color: black;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.inspectIcon > i:hover {
		color: var(--brand-accent);
	}

	.popupContainer{

		width: 100%;
		height: 100%;
		/*background-color: orange;*/
		/*transform: translate(5.208333333333333vw,0px);*/
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: flex-end;
		border-radius: 0.1953125vw;
		opacity: 1 !important;
		
	}


	.popupActionBtn{
		width: 55%;
		height: 50%;
		font-size: 0.9114583333333334vw;
		font-weight: 700;
		color: black;
		opacity: 0.8;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		z-index: 99;
	}

	.popupActionBtn:hover{

		opacity: 1;
		color: var(--brand-accent);
	}

</style>